import initialStore from "../initialStore";
import {
    SET_HISTORY,
    RESET_HISTORY
} from "@actions/actionTypes";
import {getHistoryByDaySum} from "@services/historyService";

export default function totalBetsReducer(state = initialStore.history, action) {
    switch (action.type) {
        case SET_HISTORY:
            // const history = getHistoryByDaySum([...state.data, ...action.bets])
            return {data: [].concat(state.data, action.items), hasNext: action.items.length  }
        case RESET_HISTORY:
            return initialStore.history
        default:
            return state;
    }
}
